var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"slide-down","appear":""}},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"txt--danger",domProps:{"innerHTML":_vm._s(_vm.multible + error)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }